export default "__VITE_ASSET__BBIwO_un__"